import Layout from 'components/layout'
import Socials from 'components/socials'
import * as ga from 'helpers/ga'
import { useWindowDimensions } from 'hooks/useWindowDimensions'
import Image from 'next/image'
import React, { ReactElement } from 'react'

const ProfileLink: React.FC<{ name: string }> = ({ name }) => (
  <a
    onClick={() => ga.event({ action: `Opened profile: ${name}`, params: {} })}
    className="text-blue"
    href={`https://twitter.com/${name}`}
    rel="noopener noreferrer"
    target="_blank"
  >
    @{name}
  </a>
)

const FAQ: React.FC<{ title: string }> = ({ title, children }) => (
  <div className="flex flex-col gap-2">
    <div className="text-h3-tight font-sans font-medium">{title}</div>
    <div className="text-body1 font-sans">{children}</div>
  </div>
)

const About = () => {
  const { width } = useWindowDimensions()
  return (
    <div className="flex flex-col-reverse justify-end lg:flex-row pt-16 min-h-screen lg:h-screen">
      <div className="p-6 lg:p-16 lg:overflow-y-scroll">
        <div className="flex flex-col gap-5 md:gap-10">
          <div className="text-subheading md:text-subtitle italic font-serif ">About</div>
          <div>
            <div className="text-body1 md:text-h3-tight font-sans font-medium pb-4">
              We’re a team of builders exploring the web3 space. Our first drop is Crypto Wrapped,
              “Spotify Wrapped” for your on-chain activity.
            </div>
            <div className="text-body1 md:text-h3-tight font-sans font-medium">
              Built by <ProfileLink name="thetkkong" />, <ProfileLink name="prathiknaidu" />,{' '}
              <ProfileLink name="seedelano" />, <ProfileLink name="jsarihan" />, kevin, and omar.
            </div>
          </div>
          <div className="text-blue">
            <Socials />
          </div>
        </div>

        <div className="mt-10 md:mt-20 flex flex-col gap-5 md:gap-10 pb-20">
          <div className="text-subheading md:text-subtitle italic font-serif">FAQ</div>
          <FAQ title="What's Crypto Wrapped?">
            Crypto Wrapped generates surprising insights for your 2021 Ethereum transactions. You
            can then mint your Crypto Wrapped as an ERC721 token on chain.
          </FAQ>

          <FAQ title="When's the pre-mint?">
            Pre-mint will open on December 27, 2021. People who responded to this{' '}
            <a
              onClick={() => ga.event({ action: 'Opened og tweet', params: {} })}
              className="text-blue"
              href="https://twitter.com/thetkkong/status/1472340568483274765"
              rel="noopener noreferrer"
              target="_blank"
            >
              tweet
            </a>{' '}
            with a valid address have been added to the pre-mint list.
          </FAQ>

          <FAQ title="When's the public mint?">
            Public mint will open on December 28, 2021. Follow <ProfileLink name="cryptowrapped" />{' '}
            on Twitter for more updates.
          </FAQ>

          <FAQ title="How do you rank Top NFTs?">
            We rank Top NFTs by the price you paid for the NFTs. If there’s no purchase price (i.e. NFT was transferred), we’ll use the Collection’s Average Price from OpenSea.
            <br/>
            <br/>
            Note: Due to limitations of the Etherscan API, we can only track ERC721s. 
          </FAQ>

          <FAQ title="How do you calculate Total Volume?">
            We calculate Total Volume by tracking all transactions for a token and converting it into ETH value on the day that we generate your Wrapped. We use CryptoCompare API to get price data by matching the token name.             
            <br/>
            <br/>
            Example: If you bought 100 $PEOPLE and sold it, your total volume would be 200 $PEOPLE. Then we’ll convert it into the current $PEOPLE price in ETH. 
            <br/>
            <br/>          
            This is due to limitations of existing APIs and challenges with tracking historical prices for all token transactions.           
          </FAQ>

          <FAQ title="How do you rank Top Tokens?">
            We rank Top Tokens by the amount of native tokens traded x current token price in ETH. 
          </FAQ>
        </div>
      </div>

      <div className="max-h-28 overflow-hidden lg:max-h-[98vh] lg:min-w-[50vw] lg:relative">
        {/*eslint-disable-next-line @next/next/no-img-element */}

        <Image
          src="/images/spiral.svg"
          layout="responsive"
          width={width < 976 ? '100px' : '540px'}
          height={width < 976 ? '150px' : '1024px'}
          objectFit="cover"
          alt="spiral holo 2021"
          priority
        />
      </div>
    </div>
  )
}

export default About

About.getLayout = function getLayout(page: ReactElement) {
  return (
    <Layout subTheme="white" hideFooter>
      {page}
    </Layout>
  )
}
